export default __webpack_public_path__ + "static/media/homepage.1307af46.mp3";